import { style } from 'typestyle'
export const noWrap = style({ whiteSpace: 'nowrap' })
